import { render, staticRenderFns } from "./sportbook-pending-matche.vue?vue&type=template&id=5ecfc4d6&scoped=true&"
import script from "./sportbook-pending-matche.vue?vue&type=script&lang=js&"
export * from "./sportbook-pending-matche.vue?vue&type=script&lang=js&"
import style0 from "./sportbook-pending-matche.vue?vue&type=style&index=0&id=5ecfc4d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecfc4d6",
  null
  
)

export default component.exports